<template>
  <div class="company-list-container">
    <w-nav-bar nav_title="屏蔽公司" @mobileLeftBtn="pageBack"></w-nav-bar>
    <div class="block-total flex-column" v-if="blockCompanies.length">
      <span class="title">已屏蔽公司（共{{blockCompanies.length}}个）</span>
      <span class="desc">以下公司的 HR 将无法查看您的简历</span>
    </div>
    <div class="company-list-content" v-if="blockCompanies.length">
      <cube-scroll :data="blockCompanies">
        <div class="blocking-list">
          <div v-for="(item, index) in blockCompanies" :key="index" class="blocking-item flex-between">
            <span class="blocking-title">{{ item.company_name }}</span>
            <div class="iconfont-container flex-center" @click="deleteBlocking(item)">
              <span class="iconfont iconx"></span>
            </div>
          </div>
        </div>
      </cube-scroll>
    </div>
    <div class="flex-center blocking-companies-zero" v-else>
      <div class="flex-column-center">
        <img src="https://files.wondercv.com/company/privacy-company-zero.png" alt="">
        <p>暂无屏蔽公司</p>
      </div>
    </div>
    <div class="privacy-footer flex-center">
      <button class="theme-button" @click="toPage">添加屏蔽公司</button>
    </div>
  </div>
</template>

<script>
	import WNavBar from '../../components/global/w-navbar'
	import { componentsMixin } from '../../assets/js/mixin/components'

	export default {
		name: 'company-list',
    mixins: [componentsMixin],
		data () {
			return {
				blockCompanies: []
			}
		},
		mounted () {
			this.getBlockList()
		},
		computed: {},
		watch: {},
		components: {
			WNavBar
		},
		methods: {
			pageBack () {
				this.$router.back()
      },
			toPage () {
				this.$router.push('/account/privacy/company-privacy')
      },
			async deleteBlocking ({ token }) {
				let res = await this.$api.user.deleteBlockingCompany(token)
        if (res.code === 1000) {
	        this.showToast('取消屏蔽成功')
          this.blockCompanies = this.blockCompanies.filter(item => item.token !== token)
        }
			},
			async getBlockList () {
				let res = await this.$api.user.getBlockingCompanies()
				if (res.code === 1000) {
					this.blockCompanies = res.data.blocking_companies
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/mixin';
  @import '@/assets/scss/global/variable';
  .company-list-container {
    @include mobile-container(44px, 78px);
    .block-total {
      padding: 26px 24px 0;
      .title {
        color: $color-title;
        font-size: $font-size-medium-x;
        line-height: 22px;
        font-weight: 500;
        margin-bottom: 6px;
      }
      .desc {
        color: #9c9c9c;
        font-size: $font-size-small;
      }
    }
    .company-list-content {
      height: calc(calc(var(--vh, 1vh) * 100) - 200px);
      .blocking-list {
        padding: 12px 24px 0;
        @include ipx-content-bottom(24px);
        .blocking-item {
          height: 54px;
          border-bottom: 1px solid #f9f9f9;
          .blocking-title {
            color: $color-title;
          }
          .iconfont-container {
            width: 14px;
            height: 14px;
            background-color: #ECECEC;
            border-radius: 50%;
            .iconfont {
              color: $color-light;
              font-size: 12px;
            }
          }
        }
      }
    }
    .blocking-companies-zero {
      position: fixed;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      img {
        width: 74px;
        height: 74px;
        object-fit: contain;
        margin-bottom: 18px;
      }
      p {
        color: $color-dark-gray
      }
    }
    .privacy-footer {
      position: fixed;
      bottom: 0;
      width: 100vw;
      padding: 18px 24px;
      background-color: $color-light;
      z-index: 9;
      button {
        width: 100%;
        height: 42px;
        border-radius: 4px;
        font-size: $font-size-medium-x;
      }
    }
  }
</style>
